import { render, staticRenderFns } from "./SendWhatsappTemplateMessage.vue?vue&type=template&id=6140229e"
import script from "./SendWhatsappTemplateMessage.vue?vue&type=script&lang=js"
export * from "./SendWhatsappTemplateMessage.vue?vue&type=script&lang=js"
import style0 from "./SendWhatsappTemplateMessage.vue?vue&type=style&index=0&id=6140229e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports